import { render, staticRenderFns } from "./AvailableDatatypes.vue?vue&type=template&id=6ff5ef05&scoped=true&"
import script from "./AvailableDatatypes.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AvailableDatatypes.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AvailableDatatypes.vue?vue&type=style&index=0&id=6ff5ef05&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff5ef05",
  null
  
)

export default component.exports